import { FormFieldBlueprint } from '@backstage/plugin-scaffolder-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';

export const azureAuthCheckerFormFieldExtension: ExtensionDefinition =
  FormFieldBlueprint.make({
    name: 'azure-auth-checker-form-field-extension',
    params: {
      field: () =>
        import('./azure-auth-checker').then(m => m.AzureAuthCheckerFormField),
    },
  });
